"use client";

import React from "react";
import { Search, X } from "lucide-react";
import { Input } from "modules/common/components/ui/Input";
import { ICON_SIZE } from "modules/common/components/navigation/Menu";

interface MobileSearchGroupProps {
  value: string;
  onChange: (value: string) => void;
  onClear?: () => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function MobileSearchGroup({
  value,
  onChange,
  onClear,
  placeholder = "Search...",
  disabled = false,
  className,
}: MobileSearchGroupProps) {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleClear = () => {
    if (onClear) {
      onClear();
    } else {
      onChange("");
    }
  };

  return (
    <Input
      type="text"
      value={value}
      className={className}
      onChange={handleInputChange}
      placeholder={placeholder}
      disabled={disabled}
      startContent={<Search size={ICON_SIZE} />}
      layout="horizontal"
      endContent={
        value && (
          <button
            onClick={handleClear}
            aria-label="Clear search"
            disabled={disabled}
            className="text-base-content/70 hover:text-base-content flex items-center"
          >
            <X size={ICON_SIZE} />
          </button>
        )
      }
    />
  );
}
